/*
 *   File : manage-roles.js
 *   Author : https://evoqins.com
 *   Description : Manage roles of admin modal component
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// packages
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

//Custom components
import { CustomSelectBox, CustomTextInput } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

//Style
import Color from "../../Style/color.scss";
import { APIService } from '../../Service';

const PERMISSION = [
    {
        id: 1,
        label: 'Sample 1',
        value: 'Sample 1',
    },
    {
        id: 2,
        label: 'Sample 2',
        value: 'Sample 2',
    },
    {
        id: 3,
        label: 'Sample',
        value: 'Sample 3'
    },
    {
        id: 4,
        label: 'Sample',
        value: 'Sample'
    }
];

const ManageRolesModal = (props) => {

    const isRendered = useRef(true);
    const [role, setRole] = useState("");
    const [roleError, setRoleError] = useState("");
    const [selectedPermission, setSelectedPermission] = useState(null);

    const [selectedPermissionError, setSelectedPermissionError] = useState("");
    const [adminCreate, setAdminCreate] = useState({});
    const [permissionList, setPermissionList] = useState([]);

    useEffect(() => {
        setRoleError("");
    }, [role]);

    useEffect(() => {
        if (props.edit !== null) {
            setRole(props.edit.name);
            const modules = props.edit.modules.map((item) => {
                return {
                    label: item.name,
                    value: item.module_id
                }
            })
            setSelectedPermission(modules.map((module) => ({ label: module.label, value: module.value })));
        }
    }, [props.edit])

    useEffect(() => {
        if (isRendered.current === true) {
            _permissionList();
        }
        isRendered.current = false;
    }, [])

    useEffect(() => {
        setSelectedPermissionError("");
    }, [selectedPermission]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("manage-role-modal-close");
        button.click();
        props.handleClose();
    };

    // handle create role
    const _handleCreate = () => {
        let is_valid = true;

        if (role.trim().length === 0) {
            setRoleError("Please provide role");
            is_valid = false;
        }
        if (selectedPermission === null) {
            setSelectedPermissionError("Please select permission");
            is_valid = false;
        }
        if (is_valid === true) {
            if (props.edit !== null) {
                _adminEdit(props.edit);
            } else {
                _adminCreate();
            }
        }
    };

    // API - Edit admin
    const _adminEdit = (role_id) => {
        setCreateLoader(true);

        let is_post = true;
        let url = 'sub-admin/roles/edit';
        let request = {
            "role_id": role_id.id,
            "name": role,
            "modules": selectedPermission.map((value) => {
                return value.value
            })
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                _handleCloseModal();
                props.roleEdited()
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setCreateLoader(false);

        })
    };

    const [createLoader, setCreateLoader] = useState(false);

    // API - create new admin
    const _adminCreate = () => {
        setCreateLoader(true);
        let is_post = true;
        let url = 'sub-admin/roles/add';
        let request = {
            "name": role,
            "modules": selectedPermission.map((value) => {
                return value.value
            })
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setAdminCreate(response.data);
                _handleCloseModal();
                props.roleAdded()
            } else {
                setAdminCreate({});
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setCreateLoader(false);
        })
    };

    // API permissions
    const _permissionList = () => {
        let is_post = true;
        let url = 'sub-admin/admin-modules';
        let request = {
            "page": 1,
            "page_size": 20,
            "query": ""
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                const permission_list = []
                response.data.data.map((item) => {
                    return (
                        permission_list.push({
                            label: item.name,
                            value: item.id
                        })
                    )
                })

                setPermissionList(permission_list)
            } else {
                setPermissionList([]);
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };

    return (
        <div className="modal fade"
            id="manage-role-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="manageRoleModalLabel"
            aria-hidden="true">

            <div className={`modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='manage-role-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.edit !== null ? 'Edit role' : 'Create new role'}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    {/* {loader ?
                        <div className='d-flex align-items-center justify-content-center min-vh-100'>
                            <img src={require("../../Assets/Image/loader.gif")}
                                draggable={false}
                                width={80}
                                height={80}
                                alt='loader'
                                className='text-center' />
                        </div>
                        : */}
                    <div className='modal-body pt-0 padding-32px-lr padding-40px-bottom'>
                        <div className='row pb-3'>
                            {/* Role */}
                            <div className='col-6'>
                                <CustomTextInput label="Role"
                                    placeholder="Enter role"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={role}
                                    error={roleError}
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setRole(e)} />
                            </div>
                        </div>

                        {/* Permissions */}
                        <CustomSelectBox title='Permissions'
                            placeholder='Select modules'
                            controlWidth='w-100'
                            required={true}
                            options={permissionList}
                            isSearchable={true}
                            isMulti={true}
                            borderColor={`0.031rem solid ${Color.arsenic}`}
                            padding="0.5rem 1rem"
                            value={selectedPermission}
                            error={selectedPermissionError}
                            onChange={(data) => setSelectedPermission(data)} />
                    </div>
                    {/* // } */}

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="Cancel"
                            className="py-3 padding-54px-lr"
                            onClick={_handleCloseModal} />
                        <PrimaryButton name={props.edit !== null ? "Update" : "Create"}
                            className="padding-70px-lr"
                            loader={createLoader}
                            onClick={_handleCreate} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageRolesModal;

ManageRolesModal.defaultProps = {
    handleClose: () => { }
};